import { useCallback, useEffect, useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { FileCheck2, Download, FileText } from "lucide-react";

const dl = async (url, params, name) => {
  try {
    const r = await client.get(url, { params, responseType: "blob" });
    const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(u), 5000);
  } catch { toast.error("Export failed"); }
};

export const AckReport = () => {
  const [data, setData] = useState(null);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [q, setQ] = useState("");
  const params = { start: start || undefined, end: end || undefined, q: q || undefined };
  const load = useCallback(() => {
    client.get("/security/acknowledgements", { params: { ...params, limit: 200 } }).then((r) => setData(r.data)).catch(() => {});
  }, [start, end, q]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { const h = setTimeout(load, 300); return () => clearTimeout(h); }, [load]);
  const rows = data?.rows || [];
  const inp = "px-2 py-1 text-[10px] font-mono bg-[#141518] border border-[#2C2D35] rounded-sm text-white";
  return (
    <div className="border border-[#2C2D35] rounded-sm" data-testid="sec-ack-report">
      <div className="px-3 py-2 border-b border-[#2C2D35] bg-[#0d0e11] font-head text-xs font-semibold flex items-center gap-2 flex-wrap">
        <FileCheck2 size={13} className="text-[#B98A1E]" /> SYSTEM-USE ACKNOWLEDGEMENTS
        <span className="font-mono text-[9px] text-[#6B7280]">CJIS 5.5.4 · notice v{data?.notice_version || "—"} · {data?.total ?? "—"} total · {data?.declined ?? 0} declined · {data?.not_presented ?? 0} API</span>
        <span className="ml-auto flex items-center gap-1.5">
          <input data-testid="sec-ack-start" type="date" value={start} onChange={(e) => setStart(e.target.value)} className={inp} />
          <input data-testid="sec-ack-end" type="date" value={end} onChange={(e) => setEnd(e.target.value)} className={inp} />
          <input data-testid="sec-ack-q" value={q} onChange={(e) => setQ(e.target.value)} placeholder="user / badge / IP" className={`${inp} w-32`} />
          <button data-testid="sec-ack-csv" onClick={() => dl("/security/acknowledgements.csv", params, "system_use_acknowledgements.csv")} className="px-2 py-1 text-[9px] font-head font-bold rounded border border-[#2C2D35] text-[#C9CDD4] hover:text-white flex items-center gap-1"><Download size={11} /> CSV</button>
          <button data-testid="sec-ack-pdf" onClick={() => dl("/security/acknowledgements.pdf", params, "System_Use_Acknowledgement_Report.pdf")} className="px-2 py-1 text-[9px] font-head font-bold rounded text-black flex items-center gap-1" style={{ background: "#B98A1E" }}><FileText size={11} /> PDF</button>
        </span>
      </div>
      {rows.length === 0 && <div className="p-3 font-mono text-[11px] text-[#6B7280]">No acknowledgements match.</div>}
      <div className="max-h-72 overflow-y-auto">
        {rows.map((r, i) => (
          <div key={r.sid || i} data-testid={`sec-ack-row-${i}`} className="px-3 py-1.5 border-b border-[#1E1F24] font-mono text-[10px] flex items-center gap-2 flex-wrap">
            <span className="text-[#6B7280]">{(r.ts || "").slice(0, 16).replace("T", " ")}Z</span>
            <span className="text-white">{r.user}</span>
            <span className="text-[#9CA3AF]">{r.badge || r.email}</span>
            <span className="text-[#6B7280]">{r.role} · {r.method}</span>
            <span className={`px-1.5 py-0.5 rounded text-[9px] font-bold ${r.acknowledged ? "bg-[#10B981]/15 text-[#10B981]" : r.presented ? "bg-[#DC2626]/15 text-[#EF4444]" : "bg-[#6B7280]/15 text-[#9CA3AF]"}`}>
              {r.acknowledged ? "ACKNOWLEDGED" : r.presented ? "DECLINED" : "NOT PRESENTED (API)"}
            </span>
            <span className="ml-auto text-[#6B7280]">{r.ip} · {(r.device || "").slice(0, 36)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
